<template>
    <div>
        <CheckboxElm
            :data-testid="testId"
            :checkboxConfig="checkboxConfig"
            :errorMessage="errorMessage"
            @change="$emit('change', $event)"></CheckboxElm>
        <div
            v-if="errorMessage"
            :data-testid="testId ? `${testId}Error` : null"
            role="alert"
            aria-live="polite"
            class="text-input-error">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
    import CheckboxElm from 'atoms/CheckboxElm';

    // Bare waive-of-cooling-rights consent checkbox + inline error, no disclaimer/button.
    // The heavier WaiveCoolingRights.vue is for the FTC payment flow; this is the plain
    // inline variant used where the submit button lives elsewhere (INTL switch plan, and
    // soon the INTL flow of SummaryFTC).
    export default {
        name: 'SimpleWaiveCoolingRights',
        components: {
            CheckboxElm,
        },
        props: {
            checkboxConfig: {
                type: Object,
                required: true,
            },
            errorMessage: {
                type: String,
                default: '',
            },
            testId: {
                type: String,
                default: '',
            },
        },
    };
</script>
